export const spEsri = {
  map: null,
  mapView: null,
  sceneView: null,
  activeView: null,
  sketchWidget: null,
  // layers
  featureLayers: {},
  mapImageLayers: {},
  imageryLayers: {},
  sceneLayers: {},
  buildingLayers: {},
  wmsLayers: {},
  wmtsLayers: {},
  sublayers: {},
  portalLayers: [],
  notPrintableLayers: [],
  rasterLayers: [],
  // variables for feature details
  feature: null,
  activeLayer: null,
  // variables for search
  multiSearchFeatureLayer: {},
  searchFeatureLayer: null,
  searchSceneLayer: null,
  graphicsLayers: {},
  highlightedSceneFeatures: {},
  // custom tools
  customGraphicsLayers: {},
  treeResults: [],

  // we use this to "attach" information about which advanced edit operation is currently being done using applyEdits request
  // that information will be used on the backend and written in the edit log
  // for example, if we use applyEdits to merge two features into one
  // that implies that 2 delete operations will be performed and 1 add operation, but it won't  be explicitly known
  // that a merge was done, this variable will store that information
  lastAdvancedEditOperation: null,
  snappingLayers: [],

  addFeatureLayer (key, value) {
    this.featureLayers[key] = value
  },
  addMapImageLayer (key, value) {
    this.mapImageLayers[key] = value
  },
  addImageryLayer (key, value) {
    this.imageryLayers[key] = value
  },
  addWmsLayer (key, value) {
    this.wmsLayers[key] = value
  },
  addWmtsLayer (key, value) {
    this.wmtsLayers[key] = value
  },
  addSceneLayerWrapper (key, value) {
    this.sceneLayers[key] = value
  },
  addBuildingLayerWrapper (key, value) {
    this.buildingLayers[key] = value
  },
  addSublayer (key, value) {
    this.sublayers[key] = value
  },
  addPortalLayer (portalLayer) {
    this.portalLayers.push(portalLayer)
  },
  addGraphicsLayer (key, value) {
    this.graphicsLayers[key] = value
  },
  deleteLayers () {
    this.featureLayers = []
    this.mapImageLayers = []
    this.imageryLayers = []
    this.sceneLayers = []
    this.portalLayers = []
    this.customGraphicsLayers = {}
  },

  addCustomGraphicsLayer (key, layer) {
    this.customGraphicsLayers[key] = layer
  },
}

// Open layers global variables
export const ol = {
  map: null,
  view: null,
  layerGroups: {},
  tocLayerGroups: {},
  layers: {},
  addLayerGroup (key, value) {
    this.layerGroups[key] = value
  },
  addTocLayerGroup (key, value) {
    this.tocLayerGroups[key] = value
  },
  addLayer (key, value) {
    this.layers[key] = value
  },
}
